export const INITIAL_ZOOM_LEVEL = 13;
export const DEFAULT_CENTER_COORDS = { lat: 33.9181012031489, lng: -118.35209230158749 };
